module.exports = __webpack_public_path__ + "img/trunk_7x2_z18.00bf99e9.svg";